import {
  type ReactNode,
  type CSSProperties,
  type ElementType,
  type ComponentPropsWithRef,
} from 'react';
import { type Spacing } from '../../../themes';
import { ContainerWrapper } from './style';

export type ContainerProps = {
  id?: string;
  children: ReactNode;
  outline?: boolean;
  outlineColor?: string;
  square?: boolean;
  shadow?: boolean;
  backgroundColor?: string;
  p?: Spacing;
  style?: CSSProperties;
  hideOverflow?: boolean;
  onClick?: () => void;
  testId?: string;
  as?: ElementType;
} & ComponentPropsWithRef<'div'>;

function Container({ children, testId, ref, ...rest }: ContainerProps) {
  return (
    <ContainerWrapper ref={ref} data-testid={testId} {...rest}>
      {children}
    </ContainerWrapper>
  );
}

export { Container };
